import { TrendingDown, TrendingUp } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import {
  Card,
  CardAction,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import type { CardProps, TrendDirection } from '@/types/dashboard.type';

type Props = {
  info: CardProps;
};

const TrendIcon = ({ direction }: { direction: TrendDirection }) => {
  if (direction === 'up') return <TrendingUp className="mr-1 h-3 w-3" />;
  if (direction === 'down') return <TrendingDown className="mr-1 h-3 w-3" />;
  return null;
};

export const DashboardCard = ({ info }: Props) => {
  const hasTrend = !!info.trendValue && !!info.trendDirection;
  const badgeVariant = info.variant === 'danger' ? 'fail' : 'success';

  return (
    <Card key={info.title} className="@container/card">
      <CardHeader>
        <CardDescription>{info.title}</CardDescription>
        <CardTitle className="text-2xl font-semibold tabular-nums @[250px]/card:text-3xl">
          {info.value}
        </CardTitle>
        {hasTrend && (
          <CardAction>
            <Badge variant={badgeVariant}>
              <TrendIcon direction={info.trendDirection!} />
              {info.trendValue}
            </Badge>
          </CardAction>
        )}
      </CardHeader>
      <CardFooter className="flex-col items-start gap-1.5 text-sm">
        {hasTrend && (
          <div className="line-clamp-1 flex gap-2 font-medium">
            {info.trendDirection === 'up' ? 'Trending up' : 'Needs attention'}
            <TrendIcon direction={info.trendDirection!} />
          </div>
        )}
        <div className="text-muted-foreground">{info.description}</div>
      </CardFooter>
    </Card>
  );
};
